// extracted by mini-css-extract-plugin
module.exports = {"protection":"ProtectionIcon__protection___2j7R0","stroked":"ProtectionIcon__stroked___uzunm","filled":"ProtectionIcon__filled___1tQjt"};